/* eslint-disable max-statements */
import { useEffect } from 'react';
import { useRevalidator } from 'react-router';
import { socket } from "../../../../../socket";
import { useSetAtom } from 'jotai';
import { notificationAtom } from "../../../../atoms";
import { t } from "../../../../../I18N";
import { ModelEvents, SuggestionEvents } from "../events";






import { ixStatus } from "../types";
import { acceptedSuggestions } from "../components/atoms/acceptedSuggestions";






const useEventHandler = ({ extractorId, updateStatus }) => {
  const setNotifications = useSetAtom(notificationAtom);
  const setAcceptedSuggestionsAtom = useSetAtom(acceptedSuggestions);
  const { revalidate } = useRevalidator();

  useEffect(() => {
    const handleModelStatus = async (
    eventExtractorId,
    modelStatus,
    _message,
    data) =>
    {
      if (eventExtractorId === extractorId) {
        updateStatus(modelStatus, data);
        await revalidate();
        setAcceptedSuggestionsAtom(new Set());
      }
    };

    const handleModelError = ({ message }) => {
      updateStatus(ixStatus.error);
      setNotifications({
        type: 'error',
        text: t('System', 'An error occurred', null, false),
        details: message
      });
    };

    const handleSuggestionSuccess = async () => {
      await revalidate();
      setNotifications({
        type: 'success',
        text: t('System', 'Suggestions have been updated', null, false)
      });
    };

    const handleSuggestionError = (message) => {
      setNotifications({
        type: 'error',
        text: t('System', 'An error occurred', null, false),
        details: message
      });
    };

    socket.on(ModelEvents.MODEL_STATUS, handleModelStatus);
    socket.on(ModelEvents.MODEL_ERROR, handleModelError);
    socket.on(SuggestionEvents.ACCEPT_SUGGESTION_SUCCESS, handleSuggestionSuccess);
    socket.on(SuggestionEvents.ACCEPT_SUGGESTION_ERROR, handleSuggestionError);

    return () => {
      socket.off(ModelEvents.MODEL_STATUS);
      socket.off(ModelEvents.MODEL_ERROR);
      socket.off(SuggestionEvents.ACCEPT_SUGGESTION_SUCCESS);
      socket.off(SuggestionEvents.ACCEPT_SUGGESTION_ERROR);
    };
  }, [extractorId]);
};

export { useEventHandler };